import styled, { css } from 'styled-components';

import { media, getThemeColor } from '@utils/styled';

import { VARIANT_QUATERNARY, VARIANT_ERROR } from '@common/constants/alertBox';
import Typography from '@common/components/Typography';
import CloseButton from '@common/components/CloseButton';
import Button, { ButtonLink } from '@common/components/Button';

const getBorderByVariant = ({ variant, theme }) => {
  switch (variant) {
    case VARIANT_QUATERNARY:
      return `2px solid ${getThemeColor('hue.blue')({ theme })}`;
    case VARIANT_ERROR:
      return 'none';
    default:
      return `1px solid ${getThemeColor('bluegrey.90')({ theme })}`;
  }
};

const getBgByVariant = ({ variant, theme }) => {
  switch (variant) {
    case VARIANT_ERROR:
      return `${getThemeColor('hue.red')({ theme })}`;
    default:
      return `${getThemeColor('bluegrey.95')({ theme })}`;
  }
};

const getTextColorByVariant = ({ variant, theme }) => {
  switch (variant) {
    case VARIANT_ERROR:
      return `${getThemeColor('grey.100')({ theme })}`;
    default:
      return 'inherit';
  }
};

export const StyledAlertBox = styled.div`
  position: relative;
  display: flex;
  ${({ theme }) => theme.getFluidSpacing('padding', 'widthBased', 3)};
  border: ${getBorderByVariant};
  border-radius: ${({ theme }) => theme.borderRadiuses['normal.1']}rem;
  background-color: ${getBgByVariant};
`;

export const AlertBoxContentWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-auto-flow: row;
  ${({ theme }) => theme.getFluidSpacing('grid-gap', 'scale', 8)};
  height: 100%;
  color: ${getTextColorByVariant};
`;

export const Title = styled(Typography).attrs({ variant: 'h6' })`
  margin: 0;
  margin-right: ${({ withSpacing }) => (withSpacing ? '5rem' : '0')};
  margin-bottom: 1rem;
  font-weight: 500;
  font-size: 1.8rem;

  @media screen and (width >= 45rem) {
    margin-bottom: 0.5rem;
    font-weight: 700;
    font-size: 2.4rem;
  }
`;

export const Subtitle = styled(Typography)`
  margin-right: ${({ withSpacing }) => (withSpacing ? '5rem' : '0')};
`;

export const Description = styled(Typography)`
  margin-right: ${({ withSpacing }) => (withSpacing ? '5rem' : '0')};
`;

const buttonStyle = css`
  margin-top: 0.5rem;
  white-space: nowrap;

  ${media.from640up`
    width: min-content !important;
  `}
`;

export const AlertButton = styled(Button)`
  ${buttonStyle}
`;

export const AlertButtonLink = styled(ButtonLink)`
  ${buttonStyle}
`;

export const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  ${({ theme }) => theme.getFluidAttribute('right', 1.2, 3)};
  ${({ theme }) => theme.getFluidAttribute('top', 1.2, 3)};
`;
